import { Firebase } from "@/helpers/firebase";
require("firebase/storage");

export function uploadPhoto(folder, id, photo) {
  //console.log(photo)
  const path = folder + "/" + id;
  //console.log(path)
  return Firebase.storage()
    .ref(path)
    .put(photo)
    .then(function(snapshot) {
      if (snapshot.state) {
        return Firebase.storage()
          .ref(path)
          .getDownloadURL()
          .catch(function(error) {
            console.log(error);
            alert("Error! ", error);
          });
      }
    }).catch((error)=>console.log(error));
}

export function uploadFile(folder, id, photo, name) {
  //console.log(photo)
  const path = folder + "/" + id + '/' + name;
  //console.log(path)
  return Firebase.storage()
    .ref(path)
    .put(photo)
    .then(function(snapshot) {
      if (snapshot.state) {
        return Firebase.storage()
          .ref(path)
          .getDownloadURL()
          .catch(function(error) {
            console.log(error);
            alert("Error! ", error);
          });
      }
    }).catch((error)=>console.log(error));
}
